import { Injectable, signal } from '@angular/core';
import type { UUID } from '@kerberos-compliance/compliance-shared-ts/common/types/uuid.type';
import type { FilterConfigs } from '@kerberos-compliance/compliance-shared-ui';
import { BaseFilterStore } from '@kerberos-compliance/compliance-shared-ui';

@Injectable()
export class TrainingUserListFilterStore extends BaseFilterStore<never> {
  protected override readonly defaultState = undefined as never;

  public readonly filterConfig: FilterConfigs = [];

  private readonly organizationIdSignal = signal<UUID | undefined>(undefined);

  public readonly organizationId = this.organizationIdSignal.asReadonly();

  /**
   * Updates the organization ID with the specified value.
   *
   * @param {UUID} id - The unique identifier of the organization to set.
   * @returns {void} This method does not return a value.
   */
  public setOrganizationId(id: UUID): void {
    this.organizationIdSignal.set(id);
  }
}
